import { LocationType, } from '@wix/ambassador-bookings-v2-booking/types';
import { rescheduleBooking } from '@wix/ambassador-bookings-v2-booking/http';
const copyClientsLocation = (oldSlot, newSlot) => {
    const formattedAddress = oldSlot.location?.formattedAddress;
    newSlot.location.formattedAddress = formattedAddress
        ? formattedAddress
        : '';
};
export const reschedule = async ({ booking, slot }, { httpClient }) => {
    const bookingId = booking.id;
    const bookingV2 = booking;
    if (bookingV2.bookedEntity?.slot?.location?.locationType === LocationType.CUSTOM) {
        copyClientsLocation(bookingV2.bookedEntity.slot, slot);
    }
    return (await httpClient.request(rescheduleBooking({
        bookingId,
        slot,
        revision: booking.revision,
    }))).data;
};
//# sourceMappingURL=reschedule.js.map